// ユーザー設定の真偽値のテキストを取得
export const getBoolText = (value?: boolean) => {
  return value ? '○' : '☓';
};
